import { SelectField } from '~/common/components';
import { useI18n, Trans } from '~/common/context';
import { Card, Col, Row, Title } from '@wyz/ui';
import {
  CustomerQuoteDiagnosisProvider,
  CustomerQuoteTarget,
} from '~/connect/schemas';

const DIAGNOSIS_PROVIDER_OPTIONS = {
  [CustomerQuoteDiagnosisProvider.TYRE_STATION]: 'Tyre Station',
  [CustomerQuoteDiagnosisProvider.T_SCAN]: 'T-Scan',
  [CustomerQuoteDiagnosisProvider.CAROOL]: 'Carool',
};

const TARGET_OPTIONS = {
  [CustomerQuoteTarget.FLEET_BACK]: 'Fleet Back',
  [CustomerQuoteTarget.SMBB]: 'SMBB',
};

const QuoteExpressForm = () => {
  const { t } = useI18n();
  return (
    <Card>
      <Card.Header>
        <Title heading='lg' color='tertiary' weight='bold'>
          <Trans i18nKey='app.entity.tab.quote' />
        </Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm={3}>
            <SelectField
              isMulti={false}
              name='quoteInformation.diagnosisProvider'
              label={<Trans i18nKey='app.entity.quote.diagnosis_provider' />}
              options={[
                ...Object.values(CustomerQuoteDiagnosisProvider).map(
                  (value) => ({
                    label: DIAGNOSIS_PROVIDER_OPTIONS[value],
                    value,
                  }),
                ),
              ]}
              placeholder={t('app.entity.quote.other')}
              isClearable={true}
            />
          </Col>
          <Col sm={3}>
            <SelectField
              isMulti={false}
              required
              label={<Trans i18nKey='app.entity.quote.express' />}
              name='quoteInformation.express'
              options={[
                { label: t('app.common.messages.yes'), value: 1 },
                { label: t('app.common.messages.no'), value: 0 },
              ]}
            />
          </Col>
          <Col sm={3}>
            <SelectField
              name='quoteInformation.target'
              label={<Trans i18nKey='app.entity.quote.target' />}
              options={Object.values(CustomerQuoteTarget).map((value) => ({
                label: TARGET_OPTIONS[value],
                value,
              }))}
              isClearable={true}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default QuoteExpressForm;
